/* src/app/merchants/merchant-adjustments/merchant-adjustments.component.css */
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
/*# sourceMappingURL=merchant-adjustments.component.css.map */
